// extracted by css-extract-rspack-plugin
module.exports =  {"timeStampWrap":"AeKw6"};